module.exports = __webpack_public_path__ + "img/loading.28dd4049.gif";